import Routers from './Route';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import { LoaderProvider } from './_helper/LoaderContext';
import { ClinicProvider } from './_helper/ClinicProvider';
import { PrivilegeContextProvider } from './_helper/PrivilegeContext';
import { NotificationProvider } from './_helper/NotificationContext';
import { BrowserRouter } from 'react-router-dom';
import { SocketProvider } from './_helper/SocketProvider';
import { PharmacyProvider } from './_helper/PharmacyProvider';
import { CurrencyProvider } from './_helper/currencyContext';
import { LicenseProvider } from './_helper/LicenseContext';
import { CollectionProvider } from './_helper/dailyCollection';
const App = () => {

  return (
    <div className='App'>
      <PharmacyProvider>
        <BrowserRouter basename="/">
          <LicenseProvider>
            <CustomizerProvider>
              <AnimationThemeProvider>
                <ClinicProvider>
                  <CollectionProvider>
                    <CurrencyProvider>
                      <PrivilegeContextProvider>
                        <LoaderProvider>
                          <NotificationProvider>
                            {/* <SocketProvider> */}
                            <Routers />
                            {/* </SocketProvider> */}
                          </NotificationProvider>
                        </LoaderProvider>
                      </PrivilegeContextProvider>
                    </CurrencyProvider>
                  </CollectionProvider>
                </ClinicProvider>
              </AnimationThemeProvider>
            </CustomizerProvider>
          </LicenseProvider>
        </BrowserRouter>
      </PharmacyProvider>
    </div >
  )
};

export default App;
